<template>
  <template v-if="contentStore.select_componentlist != null">
    <v-menu 
      v-model="dialog_com"
      location="start"
      :close-on-content-click="false"
      @update:modelValue="menu_handler"
      >
      <template v-slot:activator="{ props }">
        <div v-bind="props" style="cursor:pointer" class="d-flex justify-center">
        <div style="width:25px;height:25px;border:1px gray solid"
            :style="'background:'+value"
             />
        </div>
      </template>

      <v-card class="ma-0 pa-1">
        <v-row dense align="center" class="pa-0 ma-0">
          <v-col cols="9" class="ml-5 mt-2">
            <label style="color:black">{{title}}</label>
          </v-col>
          <v-col cols="2" class="mt-2">
            <v-btn size="small" icon class="dialog_close_btn mr-1" @click="close_com"><v-icon>mdi-close</v-icon></v-btn>
          </v-col>
        </v-row>

        <v-row dense justify="center" class="pa-0 ma-0">
          <v-col cols="11">
            <div style="background:gray;height:1px;" />
          </v-col>
        </v-row>

        <v-card-text>
          <v-container>
            <!-- 그라데이션 프리셋 목록 -->
            <v-row dense class="mb-3">
              <v-col cols="12">
                <label style="font-size:12px;color:#666">자주 사용하는 그라데이션</label>
                <div style="max-height: 120px; width:270px; overflow-y: auto; border: 1px solid #e0e0e0; border-radius: 4px; padding: 4px; margin-top: 4px;">
                  <v-row dense>
                    <v-col v-for="preset in gradientPresets" :key="preset.id" cols="6" class="pa-1">
                      <div 
                        @click="selectPreset(preset.gradient)"
                        style="height: 30px; border-radius: 4px; cursor: pointer; border: 1px solid transparent; position: relative;"
                        :style="{ background: preset.gradient, border: (useBasicPicker ? currentGradient : currentColor) === preset.gradient ? '2px solid #1976d2' : '2px solid #e0e0e0' }"
                        class="preset-item"
                      >
                      </div>
                    </v-col>
                  </v-row>
                </div>
              </v-col>
            </v-row>

            <!-- 커스텀 그라데이션 설정 -->
            <v-row dense>
              <v-col cols="12">
                <label style="font-size:12px;color:#666">커스텀 그라데이션</label>
                
                <!-- Vue3ColorPicker가 문제있다면 기본 그라데이션 편집기 사용 -->
                <template v-if="useBasicPicker">
                  <!-- 간단한 그라데이션 설정 -->
                  <div style="margin-bottom: 15px; margin-top: 8px;">
                    <label style="font-size: 12px; margin-bottom: 5px; display: block;">시작 색상</label>
                    <input 
                      type="color" 
                      v-model="gradientColors.start" 
                      @input="updateGradient"
                      style="width: 100%; height: 40px; border: none; cursor: pointer;"
                    />
                  </div>
                  
                  <div style="margin-bottom: 15px;">
                    <label style="font-size: 12px; margin-bottom: 5px; display: block;">끝 색상</label>
                    <input 
                      type="color" 
                      v-model="gradientColors.end" 
                      @input="updateGradient"
                      style="width: 100%; height: 40px; border: none; cursor: pointer;"
                    />
                  </div>

                  <div style="margin-bottom: 15px;">
                    <label style="font-size: 12px; margin-bottom: 5px; display: block;">방향 (도)</label>
                    <input 
                      type="range" 
                      min="0" 
                      max="360" 
                      v-model="gradientAngle" 
                      @input="updateGradient"
                      style="width: 100%;"
                    />
                    <div style="text-align: center; font-size: 11px;">{{ gradientAngle }}°</div>
                  </div>

                  <!-- 미리보기 -->
                  <div style="width: 100%; height: 60px; border: 1px solid #ccc; border-radius: 4px; margin-bottom: 10px;"
                       :style="{ background: currentGradient }">
                  </div>

                  <v-text-field
                    v-model="currentGradient"
                    label="그라데이션 CSS"
                    readonly
                    density="compact"
                    />
                </template>
                
                <!-- Vue3ColorPicker 사용 -->
                <template v-else>
                  <Vue3ColorPicker style="width: 270px;" class="elevation-0"
                    v-model="currentColor" 
                    mode="gradient" 
                    :show-eye-drop="true" :show-input-menu="true"
                    @update:modelValue="handleColorChange"
                    />
                </template>
              </v-col>
            </v-row>

          </v-container>
        </v-card-text> 

        <v-row dense justify="center" class="pa-0 ma-0">
          <v-col cols="11">
            <div style="background:gray;height:1px;" />
          </v-col>
        </v-row>

        <v-card-actions>
          <v-row justify="center">
          <v-btn variant="text" size="small" @click="close_com">취소</v-btn>
          <v-btn variant="text" size="small" class="ml-5" @click="save_com">선택</v-btn>
          </v-row>
        </v-card-actions>
      </v-card>

    </v-menu>
  </template>
</template>

<script>
import { useContentStore } from "@/stores/content";
import { Vue3ColorPicker } from '@cyhnkckali/vue3-color-picker';
import '@cyhnkckali/vue3-color-picker/dist/style.css'
import { allGradientPresets } from '@/assets/js/gradientPresets';

export default {

  components:{
    // Vue3ColorPicker가 사용 가능할 때만 등록
    ...(typeof Vue3ColorPicker !== 'undefined' ? { Vue3ColorPicker } : {})
  },

  props:{
    value: {
      type: String,
      required: true
    },
    title:{
      type:String,
      default(){
        return "";
      }
    },
  },

  emits: ['change'],

  setup(){
    const contentStore = useContentStore();
    return {contentStore};
  },
  
  computed: {
    // Vue3ColorPicker 사용 가능 여부 확인
    useBasicPicker() {
      return typeof Vue3ColorPicker === 'undefined';
    },

    currentGradient() {
      if (this.useBasicPicker) {
        return `linear-gradient(${this.gradientAngle}deg, ${this.gradientColors.start}, ${this.gradientColors.end})`;
      }
      return this.currentColor;
    }
  },

  data: ()=> ({
    renderCount:0,
    dialog_com : false,
    disabled:false,
    text_backup:"",
    currentColor: "",
    gradientPresets: allGradientPresets,
    
    // 기본 그라데이션 편집기용
    gradientColors: {
      start: '#ff0000',
      end: '#0000ff'
    },
    gradientAngle: 45
  }),

  methods: {

    handleColorChange() {
      // Vue3ColorPicker 사용시
      //console.log('Gradient color changed:', this.currentColor);
    },

    updateGradient() {
      // 기본 그라데이션 편집기 사용시
      //console.log('Gradient updated:', this.currentGradient);
    },

    parseGradient(gradientString) {
      // 기존 그라데이션 문자열 파싱 (간단한 버전)
      try {
        if (gradientString.includes('linear-gradient')) {
          // linear-gradient(45deg, #ff0000, #0000ff) 형태 파싱
          const match = gradientString.match(/linear-gradient\((\d+)deg,\s*([^,]+),\s*([^)]+)\)/);
          if (match) {
            this.gradientAngle = parseInt(match[1]);
            this.gradientColors.start = match[2].trim();
            this.gradientColors.end = match[3].trim();
          }
        }
      } catch (error) {
        console.warn('Failed to parse gradient:', error);
      }
    },

    //다이얼로그 닫기
    close_com () {
      if (this.useBasicPicker) {
        this.parseGradient(this.text_backup);
      } else {
        this.currentColor = this.text_backup;
      }
      this.dialog_com = false
    },

    //추가 저장
    save_com () {
      const finalValue = this.useBasicPicker ? this.currentGradient : this.currentColor;
      this.$emit('change', finalValue);
      this.dialog_com = false
    },      

    menu_handler(){
      this.text_backup = this.value;
      
      if (this.useBasicPicker) {
        this.parseGradient(this.value);
      } else {
        this.currentColor = this.value;
      }
    },

    //프리셋 선택
    selectPreset(gradient){
      if (this.useBasicPicker) {
        this.parseGradient(gradient);
      } else {
        this.currentColor = gradient;
      }
      
      // 즉시 change 이벤트 발생
      this.$emit('change', gradient);
      
      // Vue의 반응성 시스템을 강제로 트리거
      this.$forceUpdate();
    },
  },

  created(){
    //console.log("dialog gr color list created");
  },

  mounted(){
    //console.log("dialog gr color list mounted");
  },
}
</script>

<style scoped>
.preset-item:hover {
  transform: scale(1.05);
  transition: transform 0.2s;
  box-shadow: 0 2px 8px rgba(0,0,0,0.15);
}
</style>